import { Autocomplete, Box, Button, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { DataGrid } from '@mui/x-data-grid'
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

const SymptomsMaster = () => {
    const [formState, setFormState] = useState({
        symptomCode: "",
        symptomName: '',
        active: true,
    });
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const [SymptomsData, setSymptomsData] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [EditID, setEditID] = useState(null);
    const [isDelete, setisDelete] = useState(false);
    const [deletedID, setdeletedID] = useState(null);
    const [delIDs, setdelIDs] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);

    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Symptoms Master", "SubTab")?.editAccess

    useEffect(() => {
        getSymptomsMaster()
    }, [])

    const getSymptomsMaster = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.AYURVEDA_SYMPTOMS_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setSymptomsData(response?.data?.data || [])
                    }
                }).catch(e => {
                    setisloader(false)
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const AddSymptomsMaster = () => {
        try {
            if (!formState?.symptomName) {
                return errorMessage('Please Enter Symptom Name');
            }
            let data = {
                symptom_name: formState?.symptomName,
                is_active: isActive,
            }
            setisloader(true)
             let apiCall;
                if (EditID) {
                  apiCall = RestAPIService.update(EditID, data, Serviceurls.AYURVEDA_SYMPTOMS_MASTER);
                } else {
                  apiCall = RestAPIService.create(data, Serviceurls.AYURVEDA_SYMPTOMS_MASTER);
                }
                apiCall
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setFormState({
                            symptomCode: '',
                            symptomName: '',
                        });
                        setIsActive(true)
                        getSymptomsMaster()
                        setisloader(false)
                        setEditID(null)
                    }
                }).catch(e => {
                    setisloader(false)
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: msg,
        })
    }

    const successMessage = (msg) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: msg,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = SymptomsData.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        SymptomsData?.forEach((element, index) => element.sno = index + 1)

        const columns = [
            {
                field: 'sno', headerName: 'S.No', flex: 0.05, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.row.sno}</Typography>)
            },
            {
                field: 'symptom_code', headerName: 'Symptom Code', flex: 0.2,
                renderCell: (params) => (<Box>{params?.row?.symptom_code || '-'}</Box>)
            },
            {
                field: 'symptom_name', headerName: 'Symptom Name', flex: 0.3,
                renderCell: (params) => (params.row.symptom_name ? params.row.symptom_name?.length > 32 ?
                    <Tooltip title={params.row.symptom_name}><Typography fontSize={'0.9vw'}>{params.row.symptom_name?.slice(0, 30) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.symptom_name}</Typography> : '-')
            },
            {
                field: 'is_active', headerName: 'Status', flex: 0.1,
                renderCell: (params) => (<Box>{params?.row?.is_active ? "Active" : 'Inactive'}</Box>)
            },
            ...(commonDisable ? [{
                field: 'action', headerName: 'Action', flex: 0.1, headerAlign: "center", align: "center",
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <CommonEditButton size="1.5vw" onClick={() => {
                            setFormState({
                                symptomCode: params.row.symptom_code || '',
                                symptomName: params.row.symptom_name || '',
                            });
                            setEditID(params.row.id);
                            setIsActive(params.row.is_active || false);
                        }} />
                    </Stack>)
            }] : [])
        ]

        return (
            <Box sx={{ height: '64vh' }}>
                <DataGrid
                    checkboxSelection={!!commonDisable}
                    selectionModel={CheckBoxList}
                    onRowSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={SymptomsData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    pagination
                    paginationMode="client"
                    paginationModel={{
                        page: page,
                        pageSize: pageSize
                    }}
                    getRowClassName={(params) => params.row.is_active === false ? 'gray-row' : ''}
                    sx={{
                        "& .gray-row .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell[data-field='action'], & .gray-row:has(.MuiDataGrid-cell--checkbox)": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    onPaginationModelChange={(model) => {
                        setpage(model.page)
                        setpageSize(model.pageSize)
                    }}
                    headerHeight={40}
                    density='compact'
                    disableRowSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const deleteSymptomsMaster = () => {
        try {
            let ID = deletedID ? [deletedID] : (delIDs || [])
            RestAPIService.delete(Serviceurls.AYURVEDA_SYMPTOMS_MASTER + `?ids=${ID}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getSymptomsMaster()
                        setdelIDs([]);
                        setCheckBoxList([]);
                        setdeletedID(null);
                        setisDelete(false)
                    }
                }).catch(e => {
                    errorMessage(e?.response?.data?.message || e.message)
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const PopupClose = () => {
        setisDelete(false);
        setdeletedID(null)
    }

    const textBox = (label, name, val, width, disable) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    value={val}
                    disabled={disable}
                    inputProps={{maxlength : 100}}
                    sx={{ width: width, marginRight: '1vw' }}
                    label={label}
                    onChange={(e) => {
                        setFormState({ ...formState, [name]: e.target.value })
                    }}
                    variant="outlined"
                />
            </Box>
        )
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box sx={{ height: '13vh', width: '93vw', backgroundColor: "white", padding: "0.5vw" }}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    {textBox("Symptom Code", 'symptomCode', formState?.symptomCode, '15vw', true)}
                    {textBox("Symptom Name *", 'symptomName', formState?.symptomName, '15vw', false)}
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginTop: "0.5vw" }}>
                    <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} disabled={!EditID} size='small' />} label={"Active"} />
                    <Box sx={{ display: 'flex' }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw', marginRight: "0.5vw" }}
                            disabled={!commonDisable}
                            onClick={() => {
                                setFormState({
                                    symptomName: '',
                                    symptomCode: '',
                                });
                                setIsActive(true)
                                setEditID(null)
                            }}>Clear</Button>
                        <Button size='small' variant='contained' disabled={!commonDisable} sx={{ textTransform: 'capitalize', width: '7vw' }}
                            onClick={AddSymptomsMaster}>{EditID ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ height: '64vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>
            {message.isErrorMsg &&
                <ToastMsg severity={'error'} msg={message.isErrorMsgText} msgPop={msgClose} />
            }
            {message.successMsg &&
                <ToastMsg severity={'success'} msg={message.successMsgText} msgPop={msgClose} />
            }
            {isDelete &&
                <DeletePopup
                    DeletTitle={`Are you sure you want to delete this item ?`}
                    DeleteNotify={"This action cannot be undone."}
                    deleteAlertPopupClose={PopupClose}
                    removeData={deleteSymptomsMaster}
                    ButtonText={'Yes'}
                />
            }
            <Loader loaderOpen={isloader} />
        </Box>
    );
};

export default SymptomsMaster;
